import {ChangeEvent, FC, useState} from "react";
import {BottomSheet} from "../../container/ModalSheet.tsx";
import {Heading} from "../../ui-components/heading.tsx";
import {Button} from "../../ui-components/button.tsx";
import {ToastContainer} from "react-toastify";
import {useModal} from "../../context/ModalContext.tsx";
import {Input} from "../../ui-components/input.tsx";
import clsx from "clsx";
import {CampaignScheduleStatus} from "../../constants/enums.ts";
import {getPublication_id} from "../../utils/Utils.ts";
import {useAppDispatch} from "../../hooks/useAppDispatch.ts";
import {useTranslation} from "react-i18next";
import {declineActualPublicationTC} from "../../state/reducers/actualPublications-reducer.ts";

export const DeclineActualPublicationModal: FC<{ isOpen: boolean; modalId: string; onClose: () => void; }> = ({isOpen, modalId, onClose,}) => {
    const {closeModal} = useModal();
    const [inputVal, setInputVal] = useState('');
    const dispatch = useAppDispatch();
    const onChangeInputVal = (e: ChangeEvent<HTMLInputElement>) => {
        setInputVal(e.target.value);
    }
    const publication_id = getPublication_id();
    const handleJustClose = () => {
        if (modalId) {
            closeModal(modalId);
        }
    };
    const handleSubmitAndClose = () => {
        if (publication_id) {
            if (inputVal) {
                dispatch(declineActualPublicationTC(publication_id, {
                    status: CampaignScheduleStatus.DECLINED,
                    decline_reason: inputVal
                }))
            } else {
                dispatch(declineActualPublicationTC(publication_id, {
                    status: CampaignScheduleStatus.DECLINED,
                }))
            }
        }
        onClose();
    };
    const {t} = useTranslation();

    return (
        <BottomSheet isOpen={isOpen} onClose={onClose}>
            <div className="w-full px-4 flex flex-col items-center relative overflow-hidden">
                <ToastContainer className={'ToastContainer'} containerId={'publication_details_id'}
                                style={{top: "23px"}}/>
                <div className="w-10 h-0.5 bg-[var(--color-line)] my-2"></div>
                <div className={"flex flex-col justify-start items-start"}>
                    <Heading level={2} className={"text-2xl text-left mb-4 mt-4 "}>
                        {t('modals.declineActualPublication.heading')}
                    </Heading>
                    <p className="!text-sm text-left text-[var(--color-secondary-2)] mb-6">
                        {t('modals.declineActualPublication.request')}
                    </p>
                    <Input
                        value={inputVal}
                        onChange={onChangeInputVal}
                        name={'comment'}
                        className={clsx(
                            "[&>input]:!bg-white [&>input]:!border [&>input]:!border-[var(--border-color-block)] [&>input]:!text-sm [&>input]:px-[12px] [&>input]:py-[7px] inputShadow !mt-0",
                        )}
                        placeholder={t('modals.declineActualPublication.comment')}
                    />
                    <p className="!text-sm text-left text-[var(--color-secondary-2)] mb-6 mt-2">
                        {t('modals.declineActualPublication.reason')}
                    </p>
                    <div className="w-full flex gap-6">
                        <Button color={"white"}
                                className="w-full !bg-white !py-2.5 rounded-lg !border !border-[var(--btn-border-custom)] shadow-xs !text-sm !leading-5"
                                onClick={handleJustClose}>
                            {t('common.buttons.backBtn')}
                        </Button>
                        <Button color={"cyan"}
                                onClick={handleSubmitAndClose}
                                className="w-full !py-2.5 rounded-lg !bg-[var(--color-red)] before:bg-transparent text-white !text-sm !leading-5">
                            {t('common.buttons.yesFinishBtn')}
                        </Button>
                    </div>
                </div>

            </div>
        </BottomSheet>
    );
};
